import { hDeepClone } from '@/utils/helpers';
import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShStarRating from '@/components/Helpers/ShStarRating';
import ShPopconfirm from '@/components/Helpers/ShPopconfirm';
import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'AgentsListItem',

  components: {
    ShUserAvatar,
    ShStarRating,
    ShPopconfirm,
    ShButton,
  },

  props: {
    agent: {
      type: Object,
      default: () => ({}),
      require: true,
    },
    feedback: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      editableAgent: hDeepClone(this.agent),
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    accessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'];
    },
    agentIsAvailable() {
      return this.agent.is_available;
    },
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'agents/update',
        'agents/getList',
      ]);
    },
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    async handleToggleAgentAvailability() {
      try {
        const params = {
          id: this.editableAgent.id,
          is_available: !this.editableAgent.is_available || 'false',
        };
        await this.$store.dispatch('agents/update', params);
        await this.$store.dispatch('agents/getList');
        this.$notify.success({
          title: !this.agent.is_available ? 'Włączono dostępność Agentga' : 'Wyłączono dostępność Agenta',
          message: `Dostępność Agenta ${this.agent.name} została ${!this.agent.is_available ? 'włączona' : 'wyłączona'}`,
          customClass: 'callmeweb-notification',
        });
      } catch (error) {
        this.isWaitingForToggleAvailability = false;
      }
    },
    handleEditAgent() {
      this.$EventBus.$emit('AgentsListItem/SHOW_AGENT_DATA', this.editableAgent);
    },
    async handleDeleteAgent() {
      await this.$store.dispatch('agents/delete', this.agent.id);
      await this.$store.dispatch('agents/getList');
      await this.$store.dispatch('numbers/getList');
      this.$notify.success({
        title: 'Usuwanie Konsultanta',
        message: `Konsultant ${this.agent.name} został pomyślnie usunięty`,
        customClass: 'callmeweb-notification',
      });
    },
  },
  onResize() {
    this.windowWidth = window.innerWidth;
  },
};
